import { getUri as getApiUri, getWsUri } from "../utils/main";

const VALUES: { [key: string]: any } = {
  appName: 'clk-ledger',
  appTitle: 'Critical-Links : Ledger',
  apiUrl: getApiUri(),
  apiUrlWs: getWsUri(),
  apiHeaders: {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${process.env.REACT_APP_HTTP_SERVER_API_KEY}`
  },
  showDebugInConsoleLog: (process.env.REACT_APP_SHOW_DEBUG_IN_CONSOLE_LOG || false),
  wsReconnectTimeout: 1500,
  debounceValue: 750,
  ledger: {
    defaultLimit: 25,
    defaultOffset: 0,
    defaultOrder: 'ledger_entries.created DESC',
    defaultPayload: {
      filter: {
        limit: 25,
        offset: 0,
      },
      sort: {
        condition: 'ledger_entries.created DESC',
      }
    }
  }
};

const I18N: { [key: string]: string } = {
  // keywords
  undefined: 'Undefined',
  error: 'Error',
};

export const appConstants = {
  VALUES,
  I18N,
};
